import React from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

/**
 * Component representing a row of a categorical variable in a grouped partition of a timepoint
 */
const ContinuousRow = inject(
	'dataStore',
	'uiStore',
	'visStore'
)(
	observer(
		class ContinuousRow extends React.Component {
			strokeW = 4;
			drawRowDist() {
				const { variableDomain, height, row, variable, stateColor } = this.props;
				const getBinHeight = (value) =>
					((value - variableDomain[0]) / (variableDomain[1] - variableDomain[0])) * (height - this.strokeW);

				let pathString = `M 0, ${height}`,
					currentPos = [0, 0];
				row.sort((a, b) => a.key - b.key).forEach((d) => {
					const { key, patients } = d;

					const binWidth = this.props.visStore.groupScale(patients.length) || 0,
						binHeight = key === undefined ? 0 : getBinHeight(key);

					pathString += `l${0},${-binHeight - currentPos[1]} l ${binWidth}, ${0}`;
					currentPos = [binWidth + currentPos[0], -1 * binHeight];
				});
				pathString += `l 0 ${-1 * currentPos[1]} z`;

				const tooltipTitle = `${variable}: ${variableDomain[0]}~${variableDomain[1]}`;

				return (
					<Tooltip title={tooltipTitle} destroyOnHidden>
						<g className="continuousRow">
							<rect
								className="background continuousRowBackground"
								key="background"
								width={currentPos[0] || 0}
								height={height - this.strokeW}
								fill={stateColor}
								opacity={0.1}
								y={this.strokeW}
							/>
							<path d={pathString} fill="#999" />
							<rect
								className="outline"
								key="outline"
								width={currentPos[0] || 0}
								height={height - this.strokeW}
								fill="none"
								stroke={'black'}
								strokeWidth={1}
								y={this.strokeW}
							/>
							{/* <line x1={0} x2={currentPos[0]} strokeWidth={this.strokeW} stroke={this.props.stateColor} y1={height - 0.5 * this.strokeW} y2={height - 0.5 * this.strokeW} /> */}
						</g>
					</Tooltip>
				);
			}

			render() {
				return this.drawRowDist();
			}
		}
	)
);
ContinuousRow.propTypes = {
	variable: PropTypes.string,
	row: PropTypes.arrayOf(PropTypes.object).isRequired,
	height: PropTypes.number.isRequired,
	opacity: PropTypes.number.isRequired,
	// color: PropTypes.func.isRequired,
	stateColor: PropTypes.string.isRequired,
	variableDomain: MobxPropTypes.observableArrayOf(PropTypes.number).isRequired,
};
export default ContinuousRow;
